import React from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { ToastContainer } from "react-toastify";
import BackArrows from "../../Form/BackArrow/BackArrows";
import { getIcons, userRole } from "../../Constant/Constant";
import { useState } from "react";
import { FaFacebook } from "react-icons/fa6";
import IntegrationLeadSourceModel from "./IntegrationLeadSourceModel";
import IntegrationModel from "./IntegrationModel";
import { useNavigate } from "react-router-dom";

const IntegrationMainPage = () => {
  const icon = getIcons();
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen , setIsOpen] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedMedia , setSelectedMedia] = useState(null);

  const navigate = useNavigate()

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleIntergrationModel = (value) => {

    setSelectedMedia(value)
    setIsModalOpen(true)
    setIsOpen(false)
  }
  const handleBack = () => {};

  const handleConnection = (select) => {

    const path = userRole === "Admin" ? "/admin" : "/cmo"

    navigate(
        `${path}/web-hooks-connected-page`,{
            state: { selectedMedia: select }
        }
    )

  }


  return (
    <>
      <div className="pt-14 bg-appGrayBackground ">
        <AdminAppBar />
        <ToastContainer />

        {/* {Heading and Search , add } */}
        <div className="mt-[50px] px-6">
          <div className="flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-6">
                <BackArrows onClick={handleBack} />
                <h1 className="text-[32px] font-semibold">Integrations</h1>
              </div>
              <div className="flex items-center gap-4">
                <div className="relative flex  w-[385px] items-center ">
                  <img
                    src={icon.searchIcon}
                    alt=""
                    className="absolute left-4 w-5 h-5"
                  />
                  <input
                    type="text"
                    placeholder="Search Integrations"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    className="setup-search pl-10 pr-4 h-12 rounded-lg py-3 px-4 border-stone-400 shadow appearance-none border  text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  />
                </div>
                <button onClick={()=>{
                    setIsOpen(!isOpen)
                }} className="bg-customGreen text-white font-medium py-3 px-4 rounded-md">
                  Add Integration
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="px-6 mt-[50px]">
  {/* {FaceBook Card Integration} */}
  <div
    onClick={() => {
      handleConnection("Face Book");
    }}
    className="w-[427px] cursor-pointer bg-white p-5 rounded-xl shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all duration-300 ease-in-out animate-fadeIn"
  >
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        <FaFacebook className="text-4xl text-blue-500" />
        <div className="font-medium text-lg">Facebook</div>
      </div>
      <h1 className="text-base bg-slate-100 rounded-full py-2 px-3 text-customGreen transition-colors duration-300">
        Integrated
      </h1>
    </div>

    <div className="flex items-center gap-3 mt-5 text-[#404040]">
      Integration Your Facebook leads, instantly actionable in GL Funnel CRM
    </div>
  </div>
</div>

      </div>

      <IntegrationModel 
       openModel={isModalOpen}
       seletedMedia = {selectedMedia}
       closeModel ={()=>{
        setIsModalOpen(false)
        setIsOpen(true)
      }}
      
      />

      <IntegrationLeadSourceModel
      isOpen={isOpen}
      onIntegration = {handleIntergrationModel}
      close={()=>{

        setIsOpen(false)
    
      }}
      />
    </>
  );
};

export default IntegrationMainPage;
